import { render, staticRenderFns } from "./DetalleReportes.vue?vue&type=template&id=402e0d8b"
import script from "./DetalleReportes.vue?vue&type=script&lang=ts"
export * from "./DetalleReportes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports